import React, { useState, useEffect, useCallback } from 'react';
import NotificationBar from '../components/NotificationBar';
import { GET_NOTIFICATION_SETTINGS } from '../api';

const NotificationBarLayout = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [settings, setSettings] = useState(null);

    const getSettings = useCallback(async () => {
        try {
            setIsLoading(true);
            const data = await GET_NOTIFICATION_SETTINGS();
            setSettings(data.settings);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getSettings();
    }, [getSettings]);

    return (
        <>{!isLoading && settings && <NotificationBar settings={settings}/> }{children}</>
    );
};

export default NotificationBarLayout;
